import { Pressable, Text } from 'components/ui';
import styled from '@emotion/styled';
import { EmotionTheme } from 'theme/emotionTheme';

type Variant = 'primary' | 'secondary';

const getGradient = (variant: Variant) => {
  switch (variant) {
    case 'secondary':
      return 'linear-gradient(180deg, #DCEDFF 0%, #6ACBC4 100%)';
    default:
      return 'linear-gradient(180deg, #043338 0%, #2d6670 100%)';
  }
};

const GradientBox = styled('div')<{ variant: Variant; theme?: EmotionTheme }>`
  background-image: ${({ variant }) => getGradient(variant)};
  border-radius: 32px;
  padding: 16px;
  transition: all 0.1s ease-in-out;
  text-align: center;
`;

interface GradientButtonProps {
  children: React.ReactNode;
  onPress: () => void;
  variant?: Variant;
}

export const GradientButton = ({
  children,
  onPress,
  variant = 'primary',
  ...props
}: GradientButtonProps) => {
  return (
    <Pressable
      w="100%"
      onClick={onPress}
      _active={{ opacity: 0.85 }}
      {...props}
    >
      <GradientBox variant={variant}>
        <Text
          color={variant === 'secondary' ? '#043338' : 'white'}
          fontSize={'md'}
          fontWeight={600}
        >
          {children}
        </Text>
      </GradientBox>
    </Pressable>
  );
};
